import type { SVGProps } from "react";

const IconFlashTwo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="5"
        cy="5"
        r="4.75"
        fill="#22F5EE"
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M7.30378 4.78856H5.96834C5.84801 4.78856 5.75604 4.71475 5.77561 4.6343L6.25108 2.65486C6.28239 2.5252 6.04661 2.44674 5.91453 2.54249L2.55295 4.98737C2.43652 5.07248 2.52457 5.21144 2.69578 5.21144H4.03122C4.15156 5.21144 4.24352 5.28525 4.22396 5.3657L3.74848 7.34514C3.71717 7.4748 3.95296 7.55326 4.08503 7.45751L7.44662 5.01263C7.56402 4.92752 7.47499 4.78856 7.30378 4.78856Z"
        fill="white"
      />
    </svg>
  );
};

export default IconFlashTwo;
